"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEVICE_FILTER_FIELD_KEYS = void 0;
exports.sanitizeUiFilters = sanitizeUiFilters;
var _lib = require("@kentik/ui-shared/labels/lib");
// Canonical filter field names used for admin filters, serverFilters, URL hash serialization and node whitelist.

// Import these instead of typing raw strings.
const DEVICE_FILTER_FIELD_KEYS = exports.DEVICE_FILTER_FIELD_KEYS = {
  SEARCH: 'search',
  // table text search
  VENDOR: 'vendor',
  MODEL: 'model',
  OS_NAME: 'os_name',
  OS_VERSION: 'os_version',
  SITE: 'site',
  SITE_MARKET: 'siteMarket',
  PLAN: 'plan',
  SUBTYPE: 'subtype',
  IS_ARCHIVED: 'isArchived',
  DEVICE_KENTIK_AGENT_ID: 'device_kentik_agent_id',
  DEVICE_CAPABILITIES: 'device_capabilities',
  DEVICE_CLASS: 'deviceClass',
  CREDENTIAL: 'credential',
  MONITORING_TEMPLATE_ID: 'monitoring_template_id',
  CPU_UTIL: 'cpu_util',
  MEMORY_UTIL: 'memory_util',
  TEMPERATURE_LAST: 'temperature_last',
  PERCENT_CLASSIFIED: 'percentClassified',
  FLOW_CONFIGURED: 'flowConfigured',
  NMS_CONFIGURED: 'nmsConfigured',
  FLOW_ENRICHMENT: 'flowEnrichment',
  SAMPLING: 'sampling',
  SNMP_ENRICHMENT: 'snmpEnrichment',
  ST_ENRICHMENT: 'stEnrichment',
  BGP4_ESTABLISHED: 'bgp4Established',
  BGP6_ESTABLISHED: 'bgp6Established',
  SNMP_NMS: 'snmpNms',
  ST_NMS_STATUS: 'stNmsStatus',
  ICMP_STATUS: 'icmpStatus',
  SYSLOGS_NMS: 'syslogsNms',
  TRAPS_NMS: 'trapsNms',
  LABEL: 'label',
  CONFIG_STATUS: 'configStatus',
  CONFIG_BACKUP: 'configBackup',
  AI_ADVISOR_ACCESS: 'aiAdvisorAccess'
};
const VALID_FILTER_KEYS = new Set(Object.values(DEVICE_FILTER_FIELD_KEYS));

// UI device filters use '-' for "None"/unset in multi-select values. Turn those to nulls.
const standardizeNullValues = value => {
  if (Array.isArray(value)) {
    return value.map(standardizeNullValues);
  }
  if (value && typeof value === 'object') {
    const standardizedEntries = Object.entries(value).map(([key, entry]) => [key, standardizeNullValues(entry)]);
    return Object.fromEntries(standardizedEntries);
  }
  return value === '-' ? null : value;
};

// Whitelist & translate filters object from UI to server shape.
function sanitizeUiFilters(uiFilters) {
  const serverFilters = {};
  Object.entries(uiFilters).forEach(([filterKey, filterValue]) => {
    if (VALID_FILTER_KEYS.has(filterKey) || (0, _lib.isAssetTagFilterKey)(filterKey)) {
      serverFilters[filterKey] = standardizeNullValues(filterValue);
    }
  });
  return serverFilters;
}